const subscriptions = {
  download_title: 'Télécharger les abonnements',
  export_to: 'Exporter',
  all: 'Tous',
  selected: 'Sélectionnés',
  result: 'Résultat',
  delivery: 'Livraison',
  by_email: 'Par courriel',
};

export default subscriptions;
